module.exports = __webpack_public_path__ + "static/media/pdtvid1.8c0922c9.svg";